
















































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppSwitch from '@/views/kyc-form/component/AppSwitch.vue'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import { startCase } from 'lodash/fp'
import RPA from '@company-common/model/kyc-form/CustomRPA'
import { inject } from 'inversify-props'
import { IProjectInfo } from '@master/config/IProjectInfo'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppSwitch
  }
})
export default class RiskProfileAssessmentView extends Vue {
  @inject()
  private projectInfo: IProjectInfo;

  selectedClient = 'Client 1';
  questions: { text: string; options: { text: string; point: number }[] }[] = [
    {
      text: 'What is the primary purpose of your investment?',
      options: [
        {
          text: 'Earn more interest than bank deposit rates',
          point: 1
        },
        {
          text:
            'Saving towards the purchase of a home (e.g. downpayment for home purchase)',
          point: 2
        },
        {
          text: "Saving for children's education",
          point: 3
        },
        {
          text: 'Accumulate for future lifestyle enhancement',
          point: 4
        },
        {
          text: 'Accumulate for retirement',
          point: 5
        }
      ]
    },
    {
      text: 'What is the expected time frame for your investment ?',
      options: [
        {
          text: 'Less than 1 year',
          point: 1
        },
        {
          text: '1 - 3 years',
          point: 2
        },
        {
          text: '3 - 5 years',
          point: 3
        },
        {
          text: '5 - 10 years',
          point: 4
        },
        {
          text: 'More than 10 years',
          point: 5
        }
      ]
    },
    {
      text:
        'Compared to others, how do you rate your willingness to take investment risks?',
      options: [
        {
          text: 'Extremely low risk',
          point: 1
        },
        {
          text: 'Low risk',
          point: 2
        },
        {
          text: 'Average risk',
          point: 3
        },
        {
          text: 'High risk',
          point: 4
        },
        {
          text: 'Extremely high risk',
          point: 5
        }
      ]
    },
    {
      text:
        'Would you rate protecting your investment as more important than making the investment grow?',
      options: [
        {
          text: 'Definitely yes',
          point: 1
        },
        {
          text: 'Yes',
          point: 2
        },
        {
          text: 'Neutral',
          point: 3
        },
        {
          text: 'No',
          point: 4
        },
        {
          text: 'Definitely not',
          point: 5
        }
      ]
    },
    {
      text:
        'What is the likelihood of you needing the money on the investment within your expected time-frame?',
      options: [
        {
          text: 'Very high',
          point: 1
        },
        {
          text: 'High',
          point: 2
        },
        {
          text: 'Moderate',
          point: 3
        },
        {
          text: 'Low',
          point: 4
        },
        {
          text: 'Not at all',
          point: 5
        }
      ]
    },
    {
      text: 'What is your current knowledge and experience in investments?',
      options: [
        {
          text:
            'I have most of my savings in bank deposits and I am just starting to learn about investment',
          point: 1
        },
        {
          text:
            'I have invested in fixed deposits, life insurance and investment-linked plans',
          point: 2
        },
        {
          text: 'I have invested in unit trusts',
          point: 3
        },
        {
          text:
            'I am quite knowledgeable in investment and have invested in stocks',
          point: 4
        },
        {
          text: 'I consider myself to be a sophisticated investor',
          point: 5
        }
      ]
    }
  ];

  @kycFormStore.State
  private kycForm!: KYCForm;

  clientOptionSelected (option: string): void {
    if (option === 'Client 2' && !this.isClient2Included()) {
      window.alert(
        'Client 2 is not included in this KYC Form. To include, go to "Client Summary" page and enable the checkbox.'
      )
      return
    }
    this.selectedClient = option
  }

  isClient2Included () {
    return this.kycForm.client2.personalDetails.included
  }

  get sharedRpaAttributes () {
    return this.kycForm.client1.rpa
  }

  get editingClient () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1.rpa
    } else {
      return this.kycForm.client2.rpa
    }
  }

  getQuestionnairePoint (questionIndex: number) {
    const key = `question${questionIndex + 1}`
    return this.editingClient[key]
  }

  updateQuestionnairePoint (questionIndex: number, point: number) {
    const key = `question${questionIndex + 1}`
    Object.assign(this.editingClient, { [key]: point })
  }

  get riskScore () {
    const question = this.editingClient
    let result = 0
    result += question.question1 || 0
    result += question.question2 || 0
    result += question.question3 || 0
    result += question.question4 || 0
    result += question.question5 || 0
    result += question.question6 || 0
    this.editingClient.riskScore = result
    return result
  }

  get riskProfileCalculated () {
    this.editingClient.riskProfileCalculated = this.getRiskProfile(
      this.riskScore
    )
    return this.editingClient.riskProfileCalculated
  }

  getRiskProfile (score: number) {
    if (score < 6) return '' // JPara's specific - same behavior as Linc
    switch (true) {
      case score < 11:
        return 'conservative'
      case score < 16:
        return 'moderately_conservative'
      case score < 21:
        return 'balanced'
      case score < 26:
        return 'moderately_aggressive'
      case score < 31:
        return 'aggressive'
      default:
        return ''
    }
  }

  niceRiskProfileName (profile: string) {
    return startCase(profile)
  }

  updateCompleteRpa ($event) {
    const newValue = $event.target.checked
    if (newValue) {
      const confirm = window.confirm(
        'Pressing confirm will clear out all information on this page. Continue?'
      )
      if (confirm) {
        this.kycForm.client1.rpa = new RPA()
        this.kycForm.client2.rpa = new RPA('client_1')
        this.sharedRpaAttributes.rpaCompleted = newValue
      } else {
        $event.preventDefault()
      }
    } else {
      this.sharedRpaAttributes.rpaCompleted = newValue
    }
  }
}
